// extracted by mini-css-extract-plugin
export default {"document_name":"DetachDocumentModal_document_name__r+lln","document_name__input":"DetachDocumentModal_document_name__input__4G4Eq"};